module.exports = __webpack_public_path__ + "cda424577c4f656ef72bef239bf1c97e.svg";